import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import DewPointIcon from '@/comp/common/icons/DewPointIcon';
import { MetricType } from '@/constants/metric-type.enum';
import UnitsEnum from '@/constants/unitsEnum';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { DewpointSensorNodeModel } from './DewpointSensorNodeModel';
import SensorNodeWidget from '../../components/SensorNodeWidget/SensorNodeWidget';

export class DewpointSensorFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.DewpointSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new DewpointSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <SensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={50}
        height={44}
        data={[
          {
            metric: MetricType.DewpointTemperatureCelsius,
            unit: UnitsEnum['°C'],
            Icon: <DewPointIcon />,
          },
        ]}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
